import type { ZwDedicationPage } from "../lib/zwConfig";
import { isJust, just, nothing, type Maybe } from "../lib/maybe";
import { escapeHtmlText } from "./bookTemplate";

/** Dedication paragraphs, or Nothing when disabled / empty. */
export function buildDedicationPageContent(
  page: ZwDedicationPage,
): Maybe<readonly string[]> {
  if (page.enabled !== true) return nothing;
  const paragraphs = page.text
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter((block) => block !== "");
  if (paragraphs.length === 0) return nothing;
  return just(paragraphs.map((para) => para.replace(/\n/g, " ")));
}

/**
 * Build the dedication page HTML, or Nothing when disabled / empty.
 */
export function buildDedicationPageHtml(page: ZwDedicationPage): Maybe<string> {
  const content = buildDedicationPageContent(page);
  if (isJust(content) === false) return nothing;

  const body = content.value
    .map((para) => `<p>${escapeHtmlText(para)}</p>`)
    .join("\n");

  return just(`<div class="dedication-page">\n${body}\n</div>`);
}
